import { routerApp, baseUrl, enableOnPremise } from '../app.module';
import { httpRequestGenerator } from './utilities';

routerApp.factory('PositionApiService', ['$rootScope', '$http', function($rootScope, $http) {
    var requestFunc = httpRequestGenerator(enableOnPremise, $http);
    var positions;
    return {
        loadPositions: function(id) {
            var url = baseUrl + id + "/positions";
            return requestFunc({
                    url: url,
                    method: "GET"
            });
        },
        setPositions: function(data) {
            positions = data;
        },
        getPositions: function() {
            return positions;
        }
    }
}]);